import { cn } from '@/lib/utils';

export function Logo({ className, inverted }: { className?: string; inverted?: boolean }) {
  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <svg viewBox="0 0 32 32" className="size-9 shrink-0" aria-hidden>
        <rect width="32" height="32" rx="9" fill={inverted ? '#344720' : '#233119'} />
        <path d="M9 21c0-4.5 3.1-8.5 7-10 3.9 1.5 7 5.5 7 10" fill="none" stroke="#a7c27a" strokeWidth="2.6" strokeLinecap="round" />
        <circle cx="16" cy="21.5" r="2.2" fill="#cfa851" />
      </svg>
      <div className="leading-none">
        <div className={cn('font-display text-[17px] font-semibold tracking-wide', inverted ? 'text-white' : 'text-ink')} dir="ltr">
          TAKUMI
        </div>
        <div className={cn('mt-1 text-[11px] font-semibold', inverted ? 'text-matcha-300' : 'text-matcha-600')}>
          CRM · מאצ׳ה לעסקים
        </div>
      </div>
    </div>
  );
}
